import { render, staticRenderFns } from "./KoChart.vue?vue&type=template&id=5afbb4bc"
import script from "./KoChart.vue?vue&type=script&lang=js"
export * from "./KoChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports